require('/build/app/assets/js/app.js')